/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Condition } from './Condition';
import {
    ConditionFromJSON,
    ConditionFromJSONTyped,
    ConditionToJSON,
    ConditionToJSONTyped,
} from './Condition';
import type { FromStatusEnum } from './FromStatusEnum';
import {
    FromStatusEnumFromJSON,
    FromStatusEnumFromJSONTyped,
    FromStatusEnumToJSON,
    FromStatusEnumToJSONTyped,
} from './FromStatusEnum';
import type { ToStatusEnum } from './ToStatusEnum';
import {
    ToStatusEnumFromJSON,
    ToStatusEnumFromJSONTyped,
    ToStatusEnumToJSON,
    ToStatusEnumToJSONTyped,
} from './ToStatusEnum';
import type { TransitionAction } from './TransitionAction';
import {
    TransitionActionFromJSON,
    TransitionActionFromJSONTyped,
    TransitionActionToJSON,
    TransitionActionToJSONTyped,
} from './TransitionAction';
import type { TransitionTypeEnum } from './TransitionTypeEnum';
import {
    TransitionTypeEnumFromJSON,
    TransitionTypeEnumFromJSONTyped,
    TransitionTypeEnumToJSON,
    TransitionTypeEnumToJSONTyped,
} from './TransitionTypeEnum';

/**
 * A transition with its condition and configured actions.
 * @export
 * @interface Transition
 */
export interface Transition {
    /**
     * 
     * @type {string}
     * @memberof Transition
     */
    readonly id: string;
    /**
     * 
     * @type {FromStatusEnum}
     * @memberof Transition
     */
    fromStatus: FromStatusEnum;
    /**
     * 
     * @type {ToStatusEnum}
     * @memberof Transition
     */
    toStatus: ToStatusEnum;
    /**
     * 
     * @type {TransitionTypeEnum}
     * @memberof Transition
     */
    transitionType: TransitionTypeEnum;
    /**
     * Priority of the transition. Higher number means higher priority.
     * @type {number}
     * @memberof Transition
     */
    priority?: number;
    /**
     * 
     * @type {Condition}
     * @memberof Transition
     */
    readonly condition: Condition | null;
    /**
     * 
     * @type {Array<TransitionAction>}
     * @memberof Transition
     */
    readonly actionConfigs: Array<TransitionAction>;
}



/**
 * Check if a given object implements the Transition interface.
 */
export function instanceOfTransition(value: object): value is Transition {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('fromStatus' in (value as Record<string, any>)) && !('from_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['fromStatus'] === undefined && (value as Record<string, any>)['from_status'] === undefined)) return false;
    if ((!('toStatus' in (value as Record<string, any>)) && !('to_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['toStatus'] === undefined && (value as Record<string, any>)['to_status'] === undefined)) return false;
    if ((!('transitionType' in (value as Record<string, any>)) && !('transition_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['transitionType'] === undefined && (value as Record<string, any>)['transition_type'] === undefined)) return false;
    if (!('condition' in value) || value['condition'] === undefined) return false;
    if ((!('actionConfigs' in (value as Record<string, any>)) && !('action_configs' in (value as Record<string, any>))) || ((value as Record<string, any>)['actionConfigs'] === undefined && (value as Record<string, any>)['action_configs'] === undefined)) return false;
    return true;
}

export function TransitionFromJSON(json: any): Transition {
    return TransitionFromJSONTyped(json, false);
}

export function TransitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Transition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fromStatus': FromStatusEnumFromJSON(json['from_status']),
        'toStatus': ToStatusEnumFromJSON(json['to_status']),
        'transitionType': TransitionTypeEnumFromJSON(json['transition_type']),
        'priority': json['priority'] == null ? undefined : json['priority'],
        'condition': ConditionFromJSON(json['condition']),
        'actionConfigs': ((json['action_configs'] as Array<any>).map(TransitionActionFromJSON)),
    };
}

export function TransitionToJSON(json: any): Transition {
    return TransitionToJSONTyped(json, false);
}

export function TransitionToJSONTyped(value?: Omit<Transition, 'id'|'condition'|'actionConfigs'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from_status': FromStatusEnumToJSON(value['fromStatus']),
        'to_status': ToStatusEnumToJSON(value['toStatus']),
        'transition_type': TransitionTypeEnumToJSON(value['transitionType']),
        'priority': value['priority'],
    };
}

